<template>
    <file-input ref="fileImporter"
        :accept="accept"
        v-show="false"
        @change="fileSelected"
    ></file-input>
</template>

<script>
  export default {

    props: {

      accept: {
        type: String,
        default: null
      },

      endpoint: {
        type: String,
        default: null
      }
    },

    methods: {

      trigger() {
        this.$refs.fileImporter.trigger()
      },
      
      reset() {
        this.$refs.fileImporter.reset()
      },

      fileSelected(files) {
        let formData = new FormData();
        formData.append('file', files[0]);

        axios.post(this.endpoint, formData)
          .then(resp => {
            this.reset()
            this.$emit('uploaded')
          })
          .catch(error => {
            this.reset()
            this.$emit('error', error)
          })
      },
    }
  }
</script>
